import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  page: {
    position: 'relative',
    flexDirection: 'column',
    alignItems: 'center',
  },
  backgroundContainer: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },
  backgroundImage: {
    position: 'absolute',
    objectFit: 'cover',
    width: '100%',
    height: '100%',
  },
  overlayContent: {
    position: 'absolute',
    bottom: 100,
    left: 53,

    border: '2px solid white',
    borderRadius: '5px',
    color: 'white',
    fontSize: 11,
    paddingHorizontal: 10,
    paddingVertical: 20,
    width: '35%',
  },
  title: {
    color: 'white',
    fontSize: 24,
    fontWeight: 900,
    marginBottom: 10,
  },
  subtitle: {
    color: 'white',
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 1.2,
  },
});
